import React, {ReactElement, Component, useContext, Dispatch, SetStateAction} from 'react';
import {Row, Col, Button} from 'antd';
import {Link, withRouter} from 'react-router-dom';
import {MenuUnfoldOutlined, MenuFoldOutlined} from '@ant-design/icons';
import {FormattedMessage} from 'react-intl';

// data type
import {IUserInfoType, UserInfoContext} from "../../../contexts/user-info";
import {SideFlyInContext} from "../../../contexts/side-menu-fly-in";

const BreadCrumb: React.FC = (props: any): ReactElement<any,string| (new (props:any)=> Component<any, any, any>)> =>{

    const {pathname} = props.history.location,
        {sideMenu} = props,
        user_info: IUserInfoType = useContext(UserInfoContext)[0],
        [side_fly_in, set_side_fly_in]: [boolean, Dispatch<SetStateAction<boolean>>] = useContext(SideFlyInContext);

    return (
        <Row className="table_breadcrumb_sticky">
            {sideMenu && <Col sm={1}>
                {side_fly_in ? (
                    <MenuUnfoldOutlined
                        className="card_title"
                        onClick={() => set_side_fly_in(!side_fly_in)}
                    />
                ) : (
                    <MenuFoldOutlined
                        className="card_title"
                        onClick={() => set_side_fly_in(!side_fly_in)}
                    />
                )}
            </Col>}
            <Col sm={sideMenu? 22: 24} pull={sideMenu? 1: 0} className={sideMenu? "px-30": ''}>
                <Col sm={22} className="breadcrumb_header bg_transparent breadcrumb">
                    {user_info.role !== "" && (
                        <Link to="/console">
                            <Button size="small" className="breadcrumb_btn">
                                <span className="px-6">Home</span>&gt;
                                <span className="px-6">Global</span>
                            </Button>
                        </Link>
                    )}
                    <span>&gt;</span>
                    {pathname?.includes('service/management-instance') &&<Link to="/service/instance-list">
                        <Button size="small" className="breadcrumb_btn">
                            <span className="px-6"><FormattedMessage id={'instance_list'}/></span>
                        </Button>
                    </Link>}
                    {pathname?.includes('applications-detail') &&<Link to="/applications">
                        <Button size="small" className="breadcrumb_btn">
                            <span className="px-6"><FormattedMessage id={'applications'}/></span>
                        </Button>
                    </Link>}
                </Col>
            </Col>
        </Row>
    );
};

export default withRouter(BreadCrumb) as any;
